<template>
  <ul class="preview-img-list">
    <li v-for="(photo, index) in photos" :key="index">
      <img :src="photo">

      <!-- </div> -->
    </li>
  </ul>
</template>

<script>
export default {
  props: ['photos']
}
</script>

<style scoped>
ul {
  margin: 0;
  padding: 0;
  overflow-x: auto;
  white-space: nowrap;
  border: 1px solid #eee;
  padding: 3px;
  background-color: #fff;
}
li {
  display: inline-block;
}
img {
  height: 160px;
  margin: 0;
  padding: 0;
  padding-right: 3px;
}
</style>
